import { InformationCircleIcon } from "@heroicons/react/outline";

interface Price {
  QuantityLowerRange: number;
  SalesPrice2: number;
}

interface PricingGridProps {
  prices: Price[];
  category: string;
}

export const PricingGrid = ({ prices, category }: PricingGridProps) => (
  <>
    <div className="mt-6 w-1/3 sm:w-1/2">
      {prices.map((price, i) => (
        <div className="flex items-center" key={i}>
          <InformationCircleIcon className="flex-shrink-0 w-5 h-5 text-green-500" aria-hidden="true" />
          <p className="ml-2 text-base text-gray-500">
            {price.QuantityLowerRange > 1 ? `Quantity ${price.QuantityLowerRange}+` : "Quantity 1"}
          </p>
          <p className="text-base text-gray-900 ml-auto">${price.SalesPrice2} ea</p>
        </div>
      ))}
    </div>
    {Boolean(prices.length) && (
      <p className="text-sm text-gray-400 mt-2">
        * Mix and match {category !== "Software" ? "hardware" : "software"} products 
        to receive quantity discounts.
      </p>
    )}
  </>
); 